import { render } from "./RegisterDigiQTAccount.vue?vue&type=template&id=263d3c27"
import script from "./RegisterDigiQTAccount.vue?vue&type=script&lang=js"
export * from "./RegisterDigiQTAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__